import _taggedTemplateLiteral from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    display: block;\n    box-sizing: border-box;\n    padding: ", ";\n    height: 35px;\n    text-decoration: none;\n    cursor: pointer;\n\n    ", ";\n    ", ";\n\n    ", ";\n    ", ";\n    ", ";\n\n    & > a {\n        display: block;\n        padding: ", ";\n        width: 100%;\n        height: 100%;\n        color: ", ";\n        text-decoration: none;\n    }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n              &,\n              &:hover,\n              &:focus,\n              &:active {\n                  color: ", ";\n                  background-color: transparent;\n                  pointer-events: none;\n              }\n          "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n              color: ", ";\n              font-weight: 500;\n              background-color: ", ";\n          "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n        color: ", ";\n\n        &:hover,\n        &:focus {\n            background-color: ", ";\n        }\n\n        &:active {\n            background-color: ", ";\n        }\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { useCallback } from 'react';
import styled, { css } from 'styled-components';
import { transparentize } from 'polished';
import { ellipsis, typography } from '../mixins';
import { noop } from '../helpers';

function themedStyles(_ref) {
  var palette = _ref.theme.palette;
  return css(_templateObject(), palette.text.primary, transparentize(0.96, palette.primary.main), transparentize(0.92, palette.primary.main));
}

function selected(_ref2) {
  var palette = _ref2.theme.palette,
      selected = _ref2.selected;
  return selected ? css(_templateObject2(), palette.primary.main, transparentize(0.96, palette.primary.main)) : null;
}

function disabled(_ref3) {
  var theme = _ref3.theme,
      disabled = _ref3.disabled;
  return disabled ? css(_templateObject3(), theme.palette.gray.gray300) : null;
}

var StyledListItem = styled.li(_templateObject4(), function (_ref4) {
  var isLink = _ref4.isLink;
  return isLink ? '0' : '9px 12px 0';
}, typography('body1'), ellipsis(), themedStyles, selected, disabled, function (_ref5) {
  var isLink = _ref5.isLink;
  return !isLink ? '0' : '9px 12px 0';
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.palette.text.primary;
});
export var ListItem = React.forwardRef(function (props, ref) {
  var children = props.children,
      component = props.component,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      href = props.href,
      target = props.target,
      _props$onClick = props.onClick,
      onClick = _props$onClick === void 0 ? noop : _props$onClick,
      other = __rest(props, ["children", "component", "disabled", "href", "target", "onClick"]);

  var handleClick = useCallback(function (event) {
    if (!disabled) {
      onClick(event);
    }
  }, [disabled, onClick]);
  var content = href ? React.createElement("a", {
    href: href,
    target: target
  }, children) : children;
  return React.createElement(StyledListItem, Object.assign({}, other, component && {
    as: component
  }, {
    ref: ref,
    isLink: Boolean(href),
    disabled: disabled,
    onClick: handleClick
  }), content);
});
ListItem.displayName = 'ListItem';